export const IncidentCategory = Object.freeze({
    INCIDENT: 1,
    EXERCISE: 2,
    TRAINING: 3,
});
